"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = require("react");

var context_1 = require("../validator/context");

var ValidationContext =
/** @class */
function (_super) {
  tslib_1.__extends(ValidationContext, _super);

  function ValidationContext() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.fields = [];
    _this.registerFields = {
      getFields: function getFields() {
        return _this.fields;
      },
      register: function register(field) {
        _this.fields.push(field);
      },
      unregister: function unregister(field) {
        var index = _this.fields.findIndex(function (f) {
          return f === field;
        });

        _this.fields.splice(index, 1);
      }
    };

    _this.isValid = function (formSubmitted) {
      if (formSubmitted === void 0) {
        formSubmitted = true;
      }

      _this.fields.forEach(function (f) {
        return f.setFormSubmitted(formSubmitted);
      });

      return _this.checkValidation();
    };

    _this.reset = function () {
      _this.fields.forEach(function (f) {
        return f.resetState();
      });
    };

    _this.checkValidation = function () {
      if (!_this.fields.length) {
        console.warn('@react-form-fields/core: There is no field registred');
      }

      return _this.fields.every(function (f) {
        return f.isValid();
      });
    };

    return _this;
  }

  ValidationContext.prototype.render = function () {
    return React.createElement(context_1.FieldValidation.Provider, {
      value: this.registerFields
    }, this.props.children);
  };

  return ValidationContext;
}(React.PureComponent);

exports.default = ValidationContext;